import apiClient from '../../api/apiClient';

export const getCustomerListApi = async (params) => {
  const { oemId, search = '', limit = 20, page = 1 } = params;
  
  const response = await apiClient.get('/partners/oem-partners/users/list', {
    params: { oemId, search, limit, page }
  });

  return response.data;
};